import { createPageSegmentLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs';
import { PAGE_COMMENTS_SEGMENT_KEY } from '@confluence/browser-metrics/entry-points/metric-keys';

export const PAGE_COMMENTS_METRIC = createPageSegmentLoadMetric({
	key: PAGE_COMMENTS_SEGMENT_KEY,
	timings: [
		{
			key: 'fmp',
			endMark: 'fmp',
		},
		{
			key: 'tti',
			endMark: 'tti',
		},
		{
			key: 'pageCommentsRender',
			startMark: 'pageCommentsRenderStart',
			endMark: 'pageCommentsRenderEnd',
		},
	],
});
